import React from "react";
import { FaEye, FaTrash } from "react-icons/fa";

import {
  formatUserDate,
  getAdherentsLabel,
  getRoleInfo,
  getUserCreatedDate,
  getUserName,
} from "../utils/adminUsersUtils";

function UsersTable({ users = [], deletingId, onOpen, onDelete }) {
  return (
    <section className="hidden overflow-hidden rounded-[2rem] border border-slate-200 bg-white shadow-xl shadow-slate-200/60 dark:border-white/10 dark:bg-slate-900 dark:shadow-black/20 lg:block">
      <div className="overflow-x-auto">
        <table className="w-full min-w-[1120px] text-left">
          <thead>
            <tr className="border-b border-slate-200 bg-slate-50 text-[11px] font-bold uppercase tracking-[0.14em] text-slate-400 dark:border-white/10 dark:bg-white/[0.03]">
              <th className="px-4 py-3">Création</th>
              <th className="px-4 py-3">Utilisateur</th>
              <th className="px-4 py-3">Email</th>
              <th className="px-4 py-3">Rôle</th>
              <th className="px-4 py-3">Judoka rattaché</th>
              <th className="px-4 py-3 text-right">Actions</th>
            </tr>
          </thead>

          <tbody className="divide-y divide-slate-100 dark:divide-white/10">
            {users.map((user) => {
              const role = getRoleInfo(user.role_id);
              const isDeleting = deletingId === user.id;

              return (
                <tr
                  key={user.id}
                  className="text-sm transition hover:bg-sky-50/60 dark:hover:bg-white/[0.03]"
                >
                  <td className="whitespace-nowrap px-4 py-3 font-semibold text-slate-500 dark:text-white/50">
                    {formatUserDate(getUserCreatedDate(user))}
                  </td>

                  <td className="px-4 py-3">
                    <div>
                      <p className="font-bold text-slate-950 dark:text-white">
                        {getUserName(user)}
                      </p>
                      <p className="text-xs font-semibold text-slate-400">
                        ID #{user.id}
                      </p>
                    </div>
                  </td>

                  <td className="px-4 py-3">
                    <p className="max-w-[280px] truncate font-semibold text-slate-600 dark:text-white/60">
                      {user.email || "Email non renseigné"}
                    </p>
                  </td>

                  <td className="px-4 py-3">
                    <span
                      className={`inline-flex min-h-9 items-center gap-2 rounded-2xl px-3 text-xs font-bold ${role.badge}`}
                    >
                      <span className={`h-2 w-2 rounded-full ${role.dot}`} />
                      {role.label}
                    </span>
                  </td>

                  <td className="px-4 py-3">
                    <p className="line-clamp-2 max-w-xl text-xs font-semibold leading-5 text-slate-500 dark:text-white/50">
                      {getAdherentsLabel(user)}
                    </p>
                  </td>

                  <td className="px-4 py-3 text-right">
                    <div className="inline-flex items-center gap-2">
                      <button
                        type="button"
                        onClick={() => onOpen(user)}
                        className="inline-flex min-h-10 items-center justify-center gap-2 rounded-2xl bg-blue-700 px-4 py-2 text-xs font-bold text-white transition hover:-translate-y-0.5 hover:bg-blue-800"
                      >
                        <FaEye />
                        Détails
                      </button>

                      <button
                        type="button"
                        onClick={() => onDelete(user)}
                        disabled={isDeleting}
                        className="inline-flex min-h-10 items-center justify-center gap-2 rounded-2xl bg-red-600 px-4 py-2 text-xs font-bold text-white transition hover:-translate-y-0.5 hover:bg-red-700 disabled:cursor-not-allowed disabled:bg-slate-300 disabled:text-slate-500"
                      >
                        <FaTrash />
                        {isDeleting ? "Suppression..." : "Supprimer"}
                      </button>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </section>
  );
}

export default UsersTable;